import * as ingredientActions from './ingredientActions'
import * as mixActions from './mixActions'

import { Button } from '@atd/rui-base.mui.button'
import { IconButton } from '@atd/rui-base.mui.icon-button'
import { Checkbox } from '@atd/rui-base.mui.checkbox'
import { Table } from '@atd/rui-base.mui.table'
import { TableBody } from '@atd/rui-base.mui.table-body'
import { TableHead } from '@atd/rui-base.mui.table-head'
import { TableRow } from '@atd/rui-base.mui.table-row'
import { TableCell } from '@atd/rui-base.mui.table-cell'

import AddIcon from '@mui/icons-material/Add'
import DeleteButton from '../commonComponents/deleteDialogButton'
import EditIcon from '@mui/icons-material/Create'
import EmptyState from '../commonComponents/emptyState'
import ListPaging from '../commonComponents/listPaging'
import MixEdit from './mixCreation'
import ProductError from './productError'
import ProductLoader from './productLoader'
import React from 'react'
import TableRowColumnWrapper from '../commonComponents/tableRowColumnWrapper'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { mixPrototype } from './productPrototypes'

function mapStateToProps(state, ownProps) {
    // Users are only allowed to manage/edit mixes that belong to their company
    // not universal mixes like water
    const mixProps = state.product.mixes || {}

    return {
        isLoading: mixProps.isLoading,
        error: mixProps.error,
        mixes: mixProps.data.filter(m => m.ownerPartyId == state.admin.selectedCompanyId),
        selectedCompanyId: state.admin.selectedCompanyId,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators(ingredientActions, dispatch),
        ...bindActionCreators(mixActions, dispatch),
    }
}

class MixManager extends React.Component {
    state = {
        editMixId: null,
        newMixOpen: false,
        selectedMixes: [],
        viewList: [],
        startViewIndex: 0,
        lastViewIndex: 0,
    }
    getDisabled = () => {
        return !this.props.selectedCompanyId
    }
    componentDidMount() {
        this.props.fetchCarriers()
        this.props.fetchIngredients()
        this.props.fetchMixes()
    }

    editMixRequest = (id) => {
        this.setState({editMixId: id})
    }
    onEditMixCancel = () => {
        this.setState({editMixId: null, newMixOpen: false})
    }
    onEditMixSave = (newMixData) => {
        this.props.updateMix(newMixData)
        this.setState({editMixId: null, selectedMixes: []})
    }
    newMixRequest = () => {
        this.setState({ newMixOpen: true })
    }
    onNewMixSave = (newData) => {
        this.props.addMix(newData)
        this.setState({ newMixOpen: false, selectedMixes: [] })
    }
    onMixDelete = () => {
        this.props.deleteMixes(this.state.selectedMixes).then(rVal => {
            if (rVal && !rVal.error) {
                this.setState({selectedMixes: []})
            }
        })
    }
    onViewListChanged = (newList, startIndex, lastIndex) => {
        this.setState({
            viewList: [...newList],
            startViewIndex: startIndex,
            lastViewIndex: lastIndex,
        })
    }

    toggleMix = (id) => {
        this.setState(prev => ({
            selectedMixes: prev.selectedMixes.includes(id) ? prev.selectedMixes.filter(m => m !== id) : [...prev.selectedMixes, id],
        }))
    }
    toggleAllMixes = (checked) => {
        const viewIds = this.state.viewList.map(mix => mix.id)
        this.setState(prev => {
            const others = prev.selectedMixes.filter(id => !viewIds.includes(id))

            return { selectedMixes: checked ? [...others, ...viewIds] : others }
        })
    }
    mapMixesToTableRows = (mix, index) => {
        let ingredients = 'none'
        if (mix.mixIngredients) {
            const ingNames = mix.mixIngredients.map((ing) => {
                return ing.ingredient ? (ing.ingredient.name || ing.ingredientId) : ing.ingredientId
            })
            ingredients = `(${mix.mixIngredients.length}) ${ingNames.join(', ')}`
        }

        return (
            <TableRow
                key={mix.id}
                selected={this.state.selectedMixes.includes(mix.id)}
                name={mix.id}
                hover
                onClick={() => { if (!this.getDisabled()) this.toggleMix(mix.id) }}
                sx={{ cursor: this.getDisabled() ? 'default' : 'pointer' }}
            >
                <TableCell padding="checkbox" sx={{ pl: 0, width: 'auto' }} onClick={(e) => e.stopPropagation()}>
                    <Checkbox
                        size="small"
                        sx={{ p: 0.25 }}
                        checked={this.state.selectedMixes.includes(mix.id)}
                        disabled={this.getDisabled()}
                        onChange={() => this.toggleMix(mix.id)}
                        name={`select-${mix.id}`}
                    />
                </TableCell>
                <TableCell className="pmColumn">{mix.name}</TableCell>
                <TableCell className="pmColumn">{mix.carrier ? mix.carrier.name : ''}</TableCell>
                <TableCell className="pmColumn">{ingredients}</TableCell>
                <TableRowColumnWrapper className="pmColumn">
                    <IconButton
                        disabled={this.getDisabled()}
                        onClick={() => { this.editMixRequest(mix.id) }}
                        name={`edit-${mix.id}`}><EditIcon htmlColor={this.getDisabled() ? '#bdbdbd' : '#006495'} />
                    </IconButton>
                </TableRowColumnWrapper>
            </TableRow>
        )
    }
    renderMixEdit = () => {
        if (!this.state.editMixId && !this.state.newMixOpen) return
        let mix

        if (this.state.editMixId) {
            mix = this.props.mixes.find(element => {
                return element.id === this.state.editMixId
            })
        }
        else {
            mix = new mixPrototype('')
        }

        return (
            <MixEdit
                open={true}
                data={mix}
                onSave={this.state.editMixId ? this.onEditMixSave : this.onNewMixSave}
                onCancel={this.onEditMixCancel}
            />
        )
    }
    renderEmptyState = (mixEdit) => {
        return (
            <EmptyState>
                <div style={{paddingTop: '40px'}} >
                    <h3>No mixes found</h3>
                    <div style={{margin: '20px 0'}}>
                        <Button variant="contained"
                            onClick={this.newMixRequest}
                            startIcon={<AddIcon htmlColor="white"/>}
                            color="primary"
                            fullWidth={false}>Create Mix</Button>
                    </div>
                    {mixEdit}
                </div>
            </EmptyState>
        )
    }
    renderTable = (mixEdit) => {
        const mixRows = this.state.viewList.map(this.mapMixesToTableRows)
        const viewIds = this.state.viewList.map(mix => mix.id)
        const allChecked = viewIds.length > 0 && viewIds.every(id => this.state.selectedMixes.includes(id))
        const someChecked = !allChecked && viewIds.some(id => this.state.selectedMixes.includes(id))

        return (
            <div>
                <div style={{display: 'flex', alignItems: 'center', flexWrap: 'wrap', marginBottom: 10}}>
                    <Button variant="contained"
                        color="primary"
                        startIcon={<AddIcon htmlColor="white"/>}
                        onClick={this.newMixRequest}
                        disabled={this.getDisabled()}
                        name="addMix"
                        style={{marginRight: 10}}>Add Mix</Button>
                    <DeleteButton
                        itemType="mix"
                        deleteFunction={this.onMixDelete}
                        primary={true}
                        disabled={!this.state.selectedMixes.length || this.getDisabled()}
                        customContent={'Are you sure you wish to delete these mixes? This will not affect any generated jobs'}
                        flat={false}
                    />
                </div>
                <Table
                    className="pmTable"
                    style={{ tableLayout: 'auto', whiteSpace: 'normal' }}
                    name="pmTable"
                >
                    <TableHead >
                        <TableRow>
                            <TableCell padding="checkbox" sx={{ pl: 0, width: 'auto' }}>
                                <Checkbox
                                    size="small"
                                    sx={{ p: 0.25 }}
                                    checked={allChecked}
                                    indeterminate={someChecked}
                                    disabled={this.getDisabled()}
                                    onChange={(e) => this.toggleAllMixes(e.target.checked)}
                                    name="selectAllMixes"
                                />
                            </TableCell>
                            <TableCell className="pmColumn">{'Name'}</TableCell>
                            <TableCell className="pmColumn">{'Carrier'}</TableCell>
                            <TableCell className="pmColumn">{'Ingredients'}</TableCell>
                            <TableCell className="pmColumn">{''}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody >
                        {mixRows}
                    </TableBody>
                </Table>
                <ListPaging
                    countPerPage={15}
                    disabled={this.getDisabled()}
                    itemList={this.props.mixes}
                    viewListChanged={this.onViewListChanged}
                />
                {mixEdit}
            </div>
        )
    }
    render() {
        const mixEdit = this.renderMixEdit()

        return (
            <>
                {this.props.isLoading && !this.props.error && <ProductLoader />}
                {!this.props.isLoading && !this.props.error && !this.props.mixes.length && this.renderEmptyState(mixEdit)}
                {!this.props.isLoading && this.props.error && <ProductError error={this.props.error} />}
                {!this.props.isLoading && !this.props.error && this.props.mixes.length !== 0 && this.renderTable(mixEdit)}
            </>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MixManager)
